export const MESSAGE_TYPE_NO_MESSAGE = 0;
export const MESSAGE_TYPE_SUCCESS = 1;
export const MESSAGE_TYPE_ERROR = 2;